import UpdateUser from '@/services/users/UpdateUser';
import FetchUserData from '@/services/users/userService/FetchUserData';
import GetOutstandingOrders from '@/services/users/userService/GetOutstandingOrders';
import PayOutstandingOrders from '@/services/users/userService/PayOutstandingOrders';
import FetchStripeTerminalToken from '@/services/users/userService/FetchStripeTerminalToken';
import FetchStripeSetupIntent from '@/services/users/userService/FetchStripeSetupIntent';

export default class UserService {
    fetchUserData(isCanvasser) {
        return (new FetchUserData()).handle(isCanvasser);
    }

    updateUser(payload) {
        return (new UpdateUser()).handle(payload);
    }
    getOutstandingOrders(userId) {
        return (new GetOutstandingOrders()).handle(userId);
    }

    payOutstandingOrders(userId, payload) {
        return (new PayOutstandingOrders()).handle(userId, payload);
    }

    fetchStripeTerminalToken() {
        return (new FetchStripeTerminalToken()).handle();
    }

    fetchStripeSetupIntent(payload) {
        return (new FetchStripeSetupIntent()).handle(payload);
    }
}
